import { FieldOptions } from "../../../../app/user/profile/profileUtils";

export function moveObjectToEndById(list: FieldOptions[], objectId: string) {
  if(!list) {
    return
  }
  
  const index = list.findIndex(item => item.id === objectId);

  if (index !== -1) {
    const itemToMove = list[index];

    // Create a new array without the item to move
    const newList = list.filter(item => item.id !== objectId);

    // Add the item to move at the end of the new array
    newList.push(itemToMove);

    return newList;
  }

  // If the item is not found, return the original list
  return list;
}
